import { FC } from 'react';

import { TabOption } from 'Modules/ui3';

import { InvestorBlock } from '../InvestorBlock';
import { IssuerBlock } from '../IssuerBlock';
import { ListForTranslate } from '../../../utils';
import { Role } from '../types';


interface Tab {
    tKey: string;
    role: Role;
    component: FC<any>;
}
const tabs: Tab[] = [
    {
        tKey: 'role.investor',
        role: Role.INVESTOR,
        component: InvestorBlock,
    },
    {
        tKey: 'role.issuer',
        role: Role.ISSUER,
        component: IssuerBlock,
    },
];
export const tabsOptions: ListForTranslate<TabOption> = tabs.map(
    ({ component, role, ...props }) => ({ ...props, value: role }),
);

export const componentByRoleMap: Record<Tab['role'], Tab['component']> = tabs.reduce((obj, tab) => ({
    ...obj,
    [tab.role]: tab.component,
}), {} as Record<Tab['role'], Tab['component']>);

export const basePrices: Record<Role, number[]> = {
    [Role.INVESTOR]: [100_000, 1_000_000, 10_000_000],
    [Role.ISSUER]: [10_000_000, 100_000_000, 500_000_000],
};

export const PRICE_LIMITS = {
    [Role.INVESTOR]: {
        min: 100_000,
        max: 999_999_999_999,
    },
    [Role.ISSUER]: {
        min: 1_000_000,
        max: 999_999_999_999,
    },
};
